import { Component } from 'react';
var moment = require('moment');

export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            this.props.date ? moment(this.props.date).format('MMM DD, YYYY') : moment().format('MMM DD, YYYY')
        );
    }
}
